import {useMappedState} from 'redux-react-hook'

export default function useFee () {
  const mapState = state => state?.feeInfo || {}

  return useMappedState(mapState)
}
